define(function (require) {
    var $ = require('jquery');
    var hasExtralLinkConfirmMessage = window.externalLinkConfirmMessage && window.externalLinkConfirmMessage !== "";
    var updateExternalLinkTargets = function () {
        if (hasExtralLinkConfirmMessage) {
            // first find all the external links and set them to
            // open in a new window
            $('a:not(.skip-warn)').each(function () {
                var $this = $(this);
                if (($this.hasClass('sso-link-warn') || (this.hostname && this.hostname !== location.hostname)) && !$this.hasClass('no-tab')) {
                    $this.attr('target', '_blank');
                }
            });
        }
    };

    if (hasExtralLinkConfirmMessage) {

        updateExternalLinkTargets();

        $(document).on('click', 'a:not(.skip-warn)', function (e) {

            var exitPromptEnabled = window.scan.exitPromptEnabled;
            if (!exitPromptEnabled) {
                return true;
            }

            var subDomain = location.hostname.split('.').slice(1).join('.');

            if (this.hostname.includes(subDomain) || (!$(this).hasClass('sso-link-warn') && (!this.hostname || this.hostname === location.hostname))) {
                return true;
            }

            var message = window.externalLinkConfirmMessage;
            var destinationLoc = "";

            if ($(this).hasClass('billpay-ext-link')) {
                message = window.billPayExternalLinkConfirmMessage;
            }

            if ($(this).hasClass('sso-link-warn')) {
                if ($(this).hasClass('sso-link-convey')) {
                    message = window.conveySSOExternalLinkConfirmMessage;
                    destinationLoc = "Convey OTC SSO";
                }
                else if ($(this).hasClass('sso-link-rally')) {
                    message = window.rallySSOExternalLinkConfirmMessage;
                    destinationLoc = "Rally SSO";
                }
                else if ($(this).hasClass('sso-link-brainhq')) {
                    message = window.brainHQSSOExternalLinkConfirmMessage;
                    destinationLoc = "BrainHQ SSO";
                }
                else if ($(this).hasClass('sso-link-eyemed')) {
                    message = window.eyemedSSOExternalLinkConfirmMessage;
                    destinationLoc = "EyeMed SSO";
                }
                else if ($(this).hasClass('sso-link-deltadental')) {
                    message = window.deltadentalSSOExternalLinkConfirmMessage;
                    destinationLoc = "Delta Dental SSO";
                }
                else {
                    message = window.esiSSOExternalLinkConfirmMessage;
                    destinationLoc = "Express Scripts SSO";
                }
            }

            if (window.userIsImpersonating) {
                alert(window.impersonationWarningMessage);
                e.preventDefault();
                return false;
            } else {
                if (!confirm(message)) {
                    // if user clicks 'no' then dont proceed to link.
                    e.preventDefault();
                    return false;
                };
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'leaveSCAN',
                    'destinationLocation': destinationLoc
                });
                return true;
            }
        });

        $(document).on('submit', 'form.form-warn', function (e) {

            var message = window.externalLinkConfirmMessage;
            if ($(this).hasClass('billpay-ext-link')) {
                message = window.billPayExternalLinkConfirmMessage;
            }

            if (!confirm(message)) {
                e.preventDefault();
                return false;
            };

            return true;
        });
    }

    return {
        setExternalLinkTargets: function () {
            updateExternalLinkTargets();
        }
    };
});
